<template>
	<v-autocomplete
		v-model="filter.value"
		:search-input.sync="filter.search"
		:label="filter.text"
		multiple
		:prepend-icon="filter.name.includes('user') ? 'person' : ''"
		chips
		clearable
		hide-selected
		deletable-chips
		no-data-text="Ничего не найдено"
		:items="filter.selectItems"
	>

		<!--
			Select работает глючно: при выборе всех юзеров по поиску 'test',
			потом в меню выбора показывались только четыре пользователя, а не все оставшиеся.
			Вероятно, это баг в компоненте autocomplete из vuetify. Искать решение лень,
			не такая уж и важная штука. Пока отключил, возможно в будущих релизах vuetify
			пофиксится само.

			ААА! Это не связано с Select All. Тоже самое и без него, если выбрать за раз 14 пунктов.

			Нашел: https://github.com/vuetifyjs/vuetify/issues/5649

			Изменил prepend-item на append-item и теперь все работает ок

		-->

		<template
			v-slot:append-item
			v-if="showSelectAll"
		>
			<v-list-item
				ripple
				@click="selectAll()"
			>
				<v-list-item-content>
					<v-list-item-title>Выбрать все</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-divider class="mt-2"></v-divider>
		</template>
	</v-autocomplete>
</template>

<script>
export default {
	props: {
		filter: Object,
	},
	computed: {
		filteredItems() {
			return this.filter.selectItems.filter(item => {
				if (!this.filter.search) return true
				else return item.toLocaleLowerCase().indexOf(this.filter.search.toLocaleLowerCase()) > -1
			})
		},
		showSelectAll() {
			return this.filter.search
				&& this.filter.search.length > 0
				&& this.filteredItems.length > 1
				&& !this.filteredItems.every(item => this.filter.value.includes(item))
		},
	},
	methods: {
		selectAll() {
			// this.$nextTick(() => {


				if (this.filter.value.length === this.filter.selectItems.length) {
					this.filter.value = []
				}
				else {
					this.filteredItems.forEach(item => {
						this.filter.value.push(item)
					})
					// this.filter.value = this.filteredItems.slice()
				}

				this.filter.search = null

			// })
		},
	},
}
</script>

<style lang="css">
</style>
